import { GridConfigModel } from 'Models'

export enum ItemsStatuses {
	OPEN = 'open',
	INACTIVE = 'inactive',
	CLOSE = 'close',
}

export const ItemsStatusesMenu = {
	[ItemsStatuses.OPEN]: {
		color: 'emerald',
		text: 'Открыт',
	},
	[ItemsStatuses.CLOSE]: {
		color: 'pink',
		text: 'Закрыт',
	},
	[ItemsStatuses.INACTIVE]: {
		color: 'blue',
		text: 'Нeактивен',
	},
}

export enum TitlesIE {
	DELETE = 'Удалить',
	CANCEL = 'Отменить',
	SURE = 'Вы уверены?',
}

export enum CustomSlugIE {
	EXPAND = 'expand',
	ICON = 'icon',
	NAME = 'name',
	ORDER = 'order',
	PARENT_ELEMENT_ID = 'parent_element_id',
	URL = 'url',
	KIND = 'kind',
	ROLE = 'role',
	ACTIONS = 'actions',
}

export const gridConfigIE: GridConfigModel = {
	columns: [
		{
			order: 0,
			slug: CustomSlugIE.EXPAND,
			name: '',
			width: '5%',
			custom: true,
		},
		{
			order: 1,
			slug: 'id',
			name: 'ID',
			width: '5%',
		},
		{
			order: 2,
			slug: CustomSlugIE.ICON,
			name: 'Иконка',
			width: '10%',
			custom: true,
		},
		{
			order: 3,
			slug: CustomSlugIE.NAME,
			name: 'Наименование',
			width: '10%',
			custom: true,
		},
		{
			order: 4,
			slug: CustomSlugIE.ORDER,
			name: 'Порядок',
			width: '10%',
			custom: true,
		},
		{
			order: 5,
			slug: CustomSlugIE.PARENT_ELEMENT_ID,
			name: 'ID родителя',
			width: '10%',
			custom: true,
		},
		{
			order: 6,
			slug: CustomSlugIE.URL,
			name: 'Адрес',
			width: '20%',
			custom: true,
		},
		{
			order: 7,
			slug: CustomSlugIE.KIND,
			name: 'Kind',
			width: '10%',
			custom: true,
		},
		{
			order: 8,
			slug: CustomSlugIE.ROLE,
			name: 'Роль',
			width: '10%',
			custom: true,
		},
		{
			order: 9,
			slug: CustomSlugIE.ACTIONS,
			name: '',
			width: '10%',
			custom: true,
		},
	],
}
